<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >

            <v-card>
                <v-form ref="form" lazy-validation @submit="onSubmit">
                    <v-card-title class="px-3">Add Date</v-card-title>
                    <v-divider></v-divider>

                    <v-container fluid>
                        <v-row>
                            <!-- Date -->
                            <v-col md="6">
                                <v-menu
                                    v-model="dateModal"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                ><template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="data.date"
                                        label="Date"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                        class="mt-0 pt-0"
                                    ></v-text-field
                                ></template>
                                    <v-date-picker
                                        v-model="data.date"
                                        @input="dateModal = false"
                                        :allowed-dates="allowedDates"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>

                            <!-- Amount -->
                            <v-col md="6">
                                <v-text-field
                                    v-model="data.amount"
                                    :rules="rules.required"
                                    required
                                    dense
                                    label="Amount"
                                    class="new-date-amount"
                                ></v-text-field>
                            </v-col>

                            <v-col v-if="success" md="12" class="py-0">
                                <v-alert type="success" text border="left" dismissible class="mb-0" dense>
                                    <div>Successfully added new payment date.</div>
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="$emit('close', false); success = false;">Close</v-btn>
                        <v-btn color="primary" type="submit">Add Date</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        visible: Boolean,
        scheduleId: Number
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
    },
    data() {
        return {
            data: { date: moment().add('1', 'day').format('YYYY-MM-DD').toString(),
                    amount: null },
            dateModal: false,
            rules: { required: [ v => !!v || 'Required' ]},
            success: false
        }
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();

            if(this.$refs.form.validate()) {
                axios({
                method: 'post',
                url: 'add-date',
                data: { data: this.data, scheduleId: this.scheduleId, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.success = true;
                    this.$emit('getSchedules');
                    this.$emit('updatePayments');
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        allowedDates: val => val >= moment().add('1', 'day').format('YYYY-MM-DD'),
    }
}
</script>

<style>
    .new-date-amount input {
        padding: 6px 0px 2px !important;
    }
</style>